exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Cardinal-paymentButton{cursor:pointer;margin:3px}.discoverWallet{width:50em;max-height:31.25em}@media screen and (max-width:375px){.discoverWallet{width:23.875em}}.cardinal-stealth{position:absolute!important;display:block!important;top:-1000px!important;left:-1000px!important;z-index:-1000!important;width:1px!important;height:1px!important}#Cardinal-discoverWallet-IFrame{width:100%;height:100%}.cardinalOverlay-open.seamless{padding:0;border-radius:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./libraries/ui/scss/genericStyles.scss
// module id = 75
// module chunks = 0 5 20